import React, { FC } from 'react';
import styles from './see_more.module.scss';

type Props = {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

export const SeeMore: FC<Props> = ({ children, onClick }) => (
  <button className={styles.seeMore} type="button" onClick={onClick}>
    {children}
  </button>
);
